module.exports = __webpack_public_path__ + "img/mobilelogo.c89086e1.png";